import gql from 'graphql-tag';
import orderStatusFragment from '../orderStatus/orderStatusInfo';
import orderTypeFragment from '../orderType/orderTypeInfo';
import customerFragment from '../customer/customerInfo';
import orderItemFragment from './orderItemInfo';
import userFragment from '../user/userInfo';
export default gql`
  fragment orderInfo on Order {
    id
    number
    referenceNumber
    comment
    date
    requestedDeliveryDate
    type {
      ...orderTypeInfo
    }
    status {
      ...orderStatusInfo
    }
    customer {
      ...customerInfo
    }
    createdBy {
      ...userInfo
    }
    items {
      ...orderItemInfo
    }
    location {
      lng
      lat
      time
      startTime
    }
    nacinPlacanja
  }
  ${orderStatusFragment}
  ${orderTypeFragment}
  ${customerFragment}
  ${orderItemFragment}
  ${userFragment}
`;